import { lazy } from "react";
import { PATHS } from "./paths";
import { DocumentsLayout } from "@pages/Documents";

export type RouteGuard = "public" | "protected" | "auth-only";

export interface AppRoute {
  path: string;
  element: React.LazyExoticComponent<React.ComponentType>;
  guard: RouteGuard;
  layout?: React.ComponentType;
}

export const routes: AppRoute[] = [
  {
    path: PATHS.LOGIN,
    element: lazy(() => import("@pages/Login")),
    guard: "auth-only"
  },
  {
    path: PATHS.DASHBOARD,
    element: lazy(() => import("@pages/Dashboard")),
    guard: "protected"
  },
  {
    path: PATHS.CADASTRO.EMPRESA,
    element: lazy(() => import("@pages/Cadastro/Empresa/EmpresaPage")),
    guard: "protected"
  },
  {
    path: PATHS.CAIXA.CONSULTAR_DOCUMENTOS,
    element: lazy(() => import("@pages/Caixa/ConsultarDocumento")),
    guard: "protected"
  },
  {
    path: PATHS.CAIXA.CONSULTAR_HISTORIA,
    element: lazy(() => import("@pages/Caixa/ConsultarHistoria")),
    guard: "protected"
  },
  {
    path: PATHS.CAIXA.MOVIMENTAR_DOCUMENTOS,
    element: lazy(() => import("@pages/Caixa/MovimentarDocumentos")),
    guard: "protected"
  },
  {
    path: PATHS.EXPURGO.NOVO_LOTE,
    element: lazy(() => import("@pages/Expurgo/NovoLoteExpurgo")),
    guard: "protected"
  },
  {
    path: PATHS.EXPURGO.EXPURGAR_CANCELAR_LOTE,
    element: lazy(() => import("@pages/Expurgo/ExpurgarCancelarLote")),
    guard: "protected"
  },
  {
    path: PATHS.EXPURGO.TERMO_EXPURGO,
    element: lazy(() => import("@pages/Expurgo/TermoExpurgo")),
    guard: "protected"
  },
  {
    path: PATHS.EXPURGO.RELATORIO_EXPIRACAO_DOCUMENTOS,
    element: lazy(() => import("@pages/Expurgo/RelatorioExpiracaoDocumentos")),
    guard: "protected"
  },
  {
    path: PATHS.DOCUMENTOS.LOCALIZAR.LOCALIZAR_POR_TIPO_DOCUMENTO,
    element: lazy(() => import("@pages/Documentos/Localizar/LocalizarPorTipoDocumento")),
    guard: "protected"
  },
  {
    path: PATHS.DOCUMENTOS.LOCALIZAR.LOCALIZAR_POR_CHAVE,
    element: lazy(() => import("@pages/Documentos/Localizar/LocalizarPorChave")),
    guard: "protected"
  },
  {
    path: PATHS.DOCUMENTOS.EMPRESTIMO.REALIZAR,
    element: lazy(() => import("@pages/Documentos/Emprestimo/RealizarEmprestimo")),
    guard: "protected"
  },
  {
    path: PATHS.DOCUMENTOS.EMPRESTIMO.REALIZAR_DEVOLUCAO,
    element: lazy(() => import("@pages/Documentos/Emprestimo/RealizarDevolucao")),
    guard: "protected"
  },
  {
    path: PATHS.DOCUMENTOS.EMPRESTIMO.ALTERAR,
    element: lazy(() => import("@pages/Documentos/Emprestimo/AlterarEmprestimo")),
    guard: "protected"
  },
  {
    path: PATHS.DOCUMENTS.OVERVIEW,
    element: lazy(() => import("@pages/Documents/Overview")),
    guard: "protected",
    layout: DocumentsLayout
  },
  {
    path: PATHS.DOCUMENTS.REPORTS.MONTHLY,
    element: lazy(() => import("@pages/Documents/Reports/Monthly")),
    guard: "protected",
    layout: DocumentsLayout
  },
  {
    path: PATHS.DOCUMENTS.REPORTS.ANNUAL,
    element: lazy(() => import("@pages/Documents/Reports/Annual")),
    guard: "protected",
    layout: DocumentsLayout
  },
  {
    path: PATHS.DOCUMENTS.REPORTS.CATEGORY.CONTRACTS,
    element: lazy(() => import("@pages/Documents/Reports/Category/Contracts")),
    guard: "protected",
    layout: DocumentsLayout
  },
  {
    path: PATHS.DOCUMENTS.REPORTS.CATEGORY.FINANCIAL,
    element: lazy(() => import("@pages/Documents/Reports/Category/Financial")),
    guard: "protected",
    layout: DocumentsLayout
  },
  {
    path: PATHS.SETTINGS.PROFILE,
    element: lazy(() => import("@pages/Settings/Profile")),
    guard: "protected"
  },
  {
    path: PATHS.SETTINGS.PREFERENCES,
    element: lazy(() => import("@pages/Settings/Preferences")),
    guard: "protected"
  },
  {
    path: PATHS.CADASTRO.PERMISSAO_REGISTRO,
    element: lazy(() => import("@pages/Cadastro/PermissaoRegistro/PermissaoRegistroPage")),
    guard: "protected"
  },
  {
    path: PATHS.CADASTRO.TIPO_DOCUMENTO.INCLUIR,
    element: lazy(() => import("@pages/Cadastro/TipoDocumento/Incluir/IncluirTipoDocumento")),
    guard: "protected"
  },
  {
    path: PATHS.CADASTRO.TIPO_DOCUMENTO.ALTERAR,
    element: lazy(() => import("@pages/Cadastro/TipoDocumento/Alterar/AlterarTipoDocumento")),
    guard: "protected"
  },
  {
    path: PATHS.CADASTRO.TIPO_DOCUMENTO.EXCLUIR,
    element: lazy(() => import("@pages/Cadastro/TipoDocumento/Excluir/ExcluirTipoDocumento")),
    guard: "protected"
  },
  {
    path: PATHS.CADASTRO.TIPO_DOCUMENTO.MOVER_DOCUMENTOS,
    element: lazy(() => import("@pages/Cadastro/TipoDocumento/MoverDocumentos/MoverTipoDocumento")),
    guard: "protected"
  },
  {
    path: PATHS.DOCUMENTOS.CADASTRO.INCLUIR,
    element: lazy(() => import("@pages/Documentos/Cadastro/IncluirDocumento")),
    guard: "protected"
  },
  {
    path: PATHS.DOCUMENTOS.CADASTRO.ALTERAR,
    element: lazy(() => import("@pages/Documentos/Cadastro/AlterarDocumento")),
    guard: "protected"
  },
  {
    path: PATHS.DOCUMENTOS.CADASTRO.EXCLUIR,
    element: lazy(() => import("@pages/Documentos/Cadastro/ExcluirDocumento")),
    guard: "protected"
  }
];

export const NotFoundPage = lazy(() => import("@pages/NotFound"));
